import { useEffect, useMemo } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useInView } from "react-intersection-observer";
import axios from "axios";
import { saffronURL } from "../Url";

export const useItemCategoryInfinite = ({
  mianURL = saffronURL,
  endpoint = "news",
  key = "connect_new",
  listKey,
  category_name,
  selectedCategory,
  selectedCountry,
  selectedLanguage,
  selectedState,
  selectedCity,
  enabled = true,
  threshold = 0.8,
  rootMargin = "300px",
  perPage = 12,
  featured,
  is_popular
}) => {

  const { ref, inView } = useInView({ threshold, rootMargin });

  const {
    data,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    isPending,
  } = useInfiniteQuery({
    queryKey: [
      key,
      endpoint,
      category_name,
      selectedCategory,
      selectedCountry,
      selectedLanguage,
      selectedState,
      selectedCity,
      mianURL,
      perPage,
      featured,
      is_popular
    ],
    enabled: enabled === true,

    queryFn: async ({ pageParam = 1 }) => {
      const res = await axios.get(`${mianURL}/api/v1/public/${endpoint}`, {
        params: {
          page: pageParam,
          per_page: perPage,
          language: selectedLanguage,
          country: selectedCountry,
          state: selectedState,
          city: selectedCity,
          category: selectedCategory,
          itemcategory: category_name,
          ...(featured === 1 && { is_featured: 1 }),
            ...(is_popular === 1 && { is_popular: 1 }),
        },
      });
      return res.data; // ✅ root response
    },

    // ✅ YOUR API: data.pagination
    getNextPageParam: (lastPage) => {
      const current = lastPage?.data?.pagination?.current_page;
      const last = lastPage?.data?.pagination?.last_page;

      if (!current || !last) return undefined;
      return current < last ? current + 1 : undefined;
    },

    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: 1000 * 60 * 10,
    // if v4 use cacheTime, if v5 use gcTime
    cacheTime: 1000 * 60 * 60 * 2,
    keepPreviousData: true,
  });

  // ✅ YOUR API: data.news
  const item = useMemo(() => {
    return data?.pages?.flatMap((p) => p?.data?.[listKey] ?? []) ?? [];
  }, [data?.pages, listKey]);


  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, isFetchingNextPage, fetchNextPage]);

  return { item, ref, hasNextPage, isFetchingNextPage, isPending, raw: data };
};
